// extracted by mini-css-extract-plugin
module.exports = {"buttons":"action_buttons__BI_Zz"};